import React from 'react';
import styled from 'styled-components';
import { Provider } from 'react-redux';
import { Reset } from 'styled-reset';
import { PersistGate } from 'redux-persist/integration/react';
import Store from './configureStore';
import RCAW from './RCAW';

/**
 * Define store and persistor objects
 */
const { store, persistor } = Store;


const CssLoadedWrapper = styled.div`
  max-width: 920px;
  background-color: #FFFFFF;
  @font-face {
    font-family: Montserrat;
    src: url(${process.env.PUBLIC_URL}/fonts/Montserrat/medium/Montserrat-Medium.eot);
    src: url(${process.env.PUBLIC_URL}/fonts/Montserrat/medium/Montserrat-Medium.eot?#iefix) format("embedded-opentype"), url(${process.env.PUBLIC_URL}/fonts/Montserrat/medium/Montserrat-Medium.woff) format("woff"), url(${process.env.PUBLIC_URL}/fonts/Montserrat/medium/Montserrat-Medium.ttf) format("truetype");
    font-weight: 400;
    font-style: normal;
    /* Regular Expression */
  }

  @font-face {
    font-family: Montserrat;
    src: url(${process.env.PUBLIC_URL}/fonts/Montserrat/bold/Montserrat-Bold.eot);
    src: url(${process.env.PUBLIC_URL}/fonts/Montserrat/bold/Montserrat-Bold.eot?#iefix) format("embedded-opentype"), url(${process.env.PUBLIC_URL}/fonts/Montserrat/bold/Montserrat-Bold.woff) format("woff"), url(${process.env.PUBLIC_URL}/fonts/Montserrat/bold/Montserrat-Bold.ttf) format("truetype");
    font-weight: 700;
    font-style: normal;
    /* Regular Expression */
  }

  @font-face {
    font-family: Montserrat;
    src: url(${process.env.PUBLIC_URL}/fonts/Montserrat/regular/Montserrat-Regular.eot);
    src: url(${process.env.PUBLIC_URL}/fonts/Montserrat/regular/Montserrat-Regular.eot?#iefix) format("embedded-opentype"), url(${process.env.PUBLIC_URL}/fonts/Montserrat/regular/Montserrat-Regular.woff) format("woff"), url(./fonts/Montserrat/regular/Montserrat-Regular.ttf) format("truetype");
    font-weight: 500;
    font-style: normal;
    /* Regular Expression */
  }

  @media screen and (min-width: 920px){
    margin-left: auto;
    margin-right: auto;
    overflow: hidden;
  }

  * {
    font-family: Montserrat, sans-serif;
  }

  .clearfix:after {
    visibility: hidden;
    display: block;
    font-size: 0;
    content: " ";
    clear: both;
    height: 0;
  }
  .clearfix { display: inline-block; }
  * html .clearfix { height: 1%; }
  .clearfix { display: block; }

  .wgw-group-item.computers:before          { background-position: top    0px left    0px; }
  .wgw-group-item.phones:before             { background-position: top    0px left -100px; }
  .wgw-group-item.textiles:before           { background-position: top    0px left -200px; }
  .wgw-group-item.plastic_container:before  { background-position: top    0px left -300px; }
  .wgw-group-item.organics:before           { background-position: top    0px left -400px; }
  .wgw-group-item.christmas:before          { background-position: top    0px left -500px; }
  .wgw-group-item.hangers:before            { background-position: top    0px left -600px; }
  .wgw-group-item.furniture:before          { background-position: top    0px left -700px; }
  .wgw-group-item.glass:before              { background-position: top    0px left -800px; }

  .wgw-group-item.television:before         { background-position: top -100px left    0px; }
  .wgw-group-item.appliances:before         { background-position: top -100px left -100px; }
  .wgw-group-item.construction:before       { background-position: top -100px left -200px; }
  .wgw-group-item.yard_waste:before         { background-position: top -100px left -300px; }
  .wgw-group-item.cartons:before            { background-position: top -100px left -400px; }
  .wgw-group-item.oil_gas:before            { background-position: top -100px left -500px; }
  .wgw-group-item.take_out:before           { background-position: top -100px left -600px; }
  .wgw-group-item.pizza:before              { background-position: top -100px left -700px; }
  .wgw-group-item.covid-19:before              { background-position: top -100px left -800px; }

  .wgw-group-item.light_bulbs:before        { background-position: top -200px left    0px; }
  .wgw-group-item.batteries:before          { background-position: top -200px left -100px; }
  .wgw-group-item.shredded_paper:before     { background-position: top -200px left -200px; }
  .wgw-group-item.paint:before              { background-position: top -200px left -300px; }
  .wgw-group-item.plastic_bags:before       { background-position: top -200px left -400px; }
  .wgw-group-item.foil:before               { background-position: top -200px left -500px; }
  .wgw-group-item.aerosol_cans:before       { background-position: top -200px left -600px; }
  .wgw-group-item.styrofoam:before          { background-position: top -200px left -700px; }
  .wgw-group-item.polystyrene:before        { background-position: top -200px left -700px; }
`;


const App = ({ pluginId }) => {
  /**
   * Right before state rehydrates
   */
  const onBeforeLift = () => {
    // Lifted
  };

  return (
    <Provider
      store={store}
    >
      {/* Store persistor */}
      <PersistGate
        loading={null}
        persistor={persistor}
        onBeforeLift={onBeforeLift}
      >
        {/* CSS RESET */}
        <Reset />

        {/* Load initial CSS to avoid an aditional css file in the final build */}
        <CssLoadedWrapper>
          <RCAW pluginId={pluginId} />
        </CssLoadedWrapper>
      </PersistGate>
    </Provider>
  );
};

export default App;
